module.exports = __webpack_public_path__ + "static/media/smartBike.92de8e64.png";